import { render, staticRenderFns } from "./public-subscription-category-card.vue?vue&type=template&id=180ae200&scoped=true&"
import script from "./public-subscription-category-card.ts?vue&type=script&lang=ts&"
export * from "./public-subscription-category-card.ts?vue&type=script&lang=ts&"
import style0 from "./public-subscription-category-card.scss?vue&type=style&index=0&id=180ae200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ae200",
  null
  
)

export default component.exports